import qs from 'qs';
import { get, set } from '@/utils/reactive-object.ts';
import { instance } from '@/api/api.ts';

const getBaseState = () => ({
    products: {},
});

export default {
    namespaced: true,
    state: getBaseState(),
    getters: {
        get: state => (product, direction) => get(state.products, [product, direction].filter(Boolean)),
    },
    mutations: {
        SET(state, { product, direction, list }) {
            set(state.products, [product, direction], list);
        },
        RESET_STATE(state) {
            Object.assign(state, getBaseState());
        },
    },
    actions: {
        async LOAD({ commit }, { product, direction }) {
            if (!product) return;

            const list = await instance.post('/platform/list', qs.stringify({ product, direction }));

            commit('SET', { product, direction, list });
        },
        RESET_STATE({ commit }) {
            commit('RESET_STATE');
        },
    },
};
